import React from "react";
import { Link } from "react-router-dom"; // 1. Import Link for navigation
import DashboardPicture from "../../assets/images/landing/GetStarted.png"; // Placeholder image path

// This is a React functional component for the landing page section.
// Styles are defined as JavaScript objects and applied inline.
// For larger projects, consider external CSS, CSS Modules, or CSS-in-JS.

const GetStarted = () => {
  // --- Style Definitions ---

  const sectionStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // Centers children horizontally
    textAlign: "center", // Centers text within children
    padding: "60px",
    fontFamily: "Poppins, sans-serif", // Changed to Poppins
    backgroundColor: "#FFFFFF", // Assuming a white page background
    color: "#333333", // Default text color
  };

  const textContentWrapperStyle = {
    maxWidth: "800px", // Limits the width of the text content for readability
    width: "100%", // Ensures it takes available width up to maxWidth
    marginBottom: "40px", // Space between text content and image
  };

  const subheadingStyle = {
    color: "#E55812", // Orange-red color from "Match skills..."
    fontSize: "1rem", // Approx 16px
    fontWeight: 500,
    marginBottom: "12px",
    fontFamily: "Poppins, sans-serif", // Poppins for subheading
  };

  const mainHeadingStyle = {
    fontSize: "clamp(2.2rem, 5vw, 3.2rem)", // Responsive font size (e.g., 35-51px)
    color: "#073214", // Dark green color from "Your Skills..."
    fontWeight: "bold",
    margin: "0 0 20px 0", // Bottom margin for spacing
    lineHeight: 1.25,
    fontFamily: "Geist, sans-serif", // Changed to Geist for main heading
  };

  const descriptionStyle = {
    fontSize: "clamp(1rem, 2.5vw, 1.125rem)", // Approx 16-18px
    color: "#64748B", // Medium-dark gray
    lineHeight: 1.7,
    maxWidth: "680px", // Controls line length for better readability
    margin: "0 auto 32px auto", // Centers block and adds bottom margin
    fontFamily: "Poppins, sans-serif", // Poppins for description
  };

  const buttonsContainerStyle = {
    display: "flex",
    justifyContent: "center", // Centers buttons in the container
    alignItems: "center",
    gap: "16px", // Space between buttons
  };

  const baseButtonStyle = {
    padding: "12px 28px",
    borderRadius: "6px",
    fontSize: "1rem", // Approx 16px
    fontWeight: 600,
    cursor: "pointer",
    border: "1px solid transparent",
    transition: "background-color 0.2s ease-in-out", // Simplified transition
    minWidth: "160px",
    fontFamily: "Poppins, sans-serif", // Poppins for buttons
    textDecoration: "none", // 3. Remove underline from link
  };

  const getStartedButtonStyle = {
    ...baseButtonStyle,
    backgroundColor: "#073214", // Dark green
    color: "white",
  };

  // const requestDemoButtonStyle = {
  //   ...baseButtonStyle,
  //   backgroundColor: "white",
  //   color: "#1F2937", // Dark text
  //   border: "1px solid #D1D5DB", // Light gray border
  // };

  const dashboardImageStyle = {
    maxWidth: "100%", // Ensures image is responsive
    width: "min(100%, 900px)", // Image takes full width up to 900px
    height: "auto", // Maintain aspect ratio
    borderRadius: "12px", // Rounded corners for the image
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)", // Subtle shadow
    display: "block", // Ensures proper rendering and centering
  };

  // Note: JS-based hover handlers have been removed in favor of using a <Link> component.
  // Hover effects for links are best handled with CSS (e.g., a className and a CSS file with a :hover selector).

  return (
    <div style={sectionStyle}>
      <div style={textContentWrapperStyle}>
        <p style={subheadingStyle}>
          Match skills, Optimize Resumes, Build careers,
        </p>
        <h1 style={mainHeadingStyle}>
          Your Skills. Your Path.
          <br />
          Powered by AI
        </h1>
        <p style={descriptionStyle}>
          SkillMatch AI doesn't just build resumes. It builds futures. Discover
          careers, match jobs, and generate a tailored Resume, all in one
          intelligent platform.
        </p>
        <div style={buttonsContainerStyle}>
          {/* 2. Replaced <button> with <Link> and added the 'to' prop */}
          <Link to="/signup" style={getStartedButtonStyle}>
            Get Started <span style={{ fontFamily: "sans-serif" }}>↗</span>
          </Link>
        </div>
      </div>

      {/* Dashboard Image Placeholder */}
      {/* 
        IMPORTANT: Replace 'dashboard-placeholder.png' with the actual path to your PNG image.
        How to use your image:
        1. Place your PNG file (e.g., 'my-dashboard.png') in the `public` folder of your React project.
           Then, change the `src` attribute below to `src="/my-dashboard.png"`.
        2. OR, if your project is set up with a bundler like Webpack (common in Create React App):
           Import the image at the top of this file: `import dashboardImageFromFile from './path/to/your/image.png';`
           Then, change the `src` attribute below to `src={dashboardImageFromFile}`.
      */}
      {/* <img
        src={DashboardPicture} // Replace this with your actual image path
        alt="SkillMatch AI Dashboard Preview"
        style={dashboardImageStyle}
      /> */}
    </div>
  );
};

export default GetStarted;
